import { render, staticRenderFns } from "./loginComponent.vue?vue&type=template&id=58dacda4&scoped=true&"
import script from "./loginComponent.vue?vue&type=script&lang=js&"
export * from "./loginComponent.vue?vue&type=script&lang=js&"
import style0 from "./loginComponent.vue?vue&type=style&index=0&id=58dacda4&lang=scss&scoped=true&"
import style1 from "./loginComponent.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58dacda4",
  null
  
)

export default component.exports